export default __webpack_public_path__ + "static/media/news-mobile.d0aae471.jpg";